import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PasswordService} from '../../../services/apiServices/security/password.service';
import {TranslateService} from '@ngx-translate/core';
import {EmailValidator} from '../../../model/email-validator';
import {instances} from '../../../properties';
import {environment} from '../../../../environments/environment';
import {CommonService} from '../../../services/apiServices/business/common.service';
import {AuthenticationService} from "../../../services/apiServices/security/authentication.service";


/**
 * component that handleChangeOfSelectFold the forgotten password action
 */
@Component({
  selector: 'app-forgotten-password',
  templateUrl: './forgotten-password.component.html',
  styleUrls: ['./forgotten-password.component.scss']
})
export class ForgottenPasswordComponent implements OnInit {

  /**
   * the email of the user that wants to reset his password
   */
  public email: string;

  /**
   * the customerID of the user
   */
  public showCustomerID: boolean;
  @Input('customerID') public customerID: string;

  /**
   * the userID of the user
   */
  @Input('userID') public userID: string;

  /**
   * if the resetPasswordFail (answer of the back-office)
   */
  public resetPasswordFail: boolean;

  /**
   * notification when the new password has been created
   */
  @Output() public forgottenSuccess: EventEmitter<boolean>;

  /**
   * Message display when the new password is ok
   */
  public successMessage: string;

  /**
   * Title of the message, display when the new password is ok
   */
  public successTitle: string;

  /**
   * if the reset password fail, then the back-office will give a message stored in errorMessage
   */
  public errorMessage: string;

  public isWsoRegistered: boolean = false;

  public bShowIsWsoRegisteredErrorMessage: boolean = false;

  public errorMessageIsWsoRegistered: string;
  /**
   *
   * default constructor that instantiate PasswordService (if not done before)
   *
   * @param {PasswordService} passwordService - the service that handleChangeOfSelectFold every request dealing with passwords
   * @param commonService
   * @param translate
   */
  constructor(private authenticationService: AuthenticationService, private passwordService: PasswordService, private commonService: CommonService, private translate: TranslateService) {
    this.forgottenSuccess = new EventEmitter<boolean>();
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('TOASTER.NEW_PASSWORD_ASK_OK').subscribe((message: string) => {
      this.successMessage = message;
    });
    this.translate.get('TOASTER.NEW_PASSWORD_ASK_KO').subscribe((message: string) => {
      this.errorMessage = message;
    });

    this.translate.get('TOASTER.IS_WSO_REGISTERED_ERROR_MESSAGE').subscribe((message: string) => {
      this.errorMessageIsWsoRegistered = message;
    });
  }

  /**
   * handleChangeOfSelectFold subscription to errorMessage (from passwordService) and translationService
   */
  public ngOnInit(): void {
    this.resetPasswordFail = false;
    /*
    this.passwordService.errorMessage.subscribe(
      error => {
        this.errorMessage = error;
      }
    );
    */

    this.getTradForComponent();
    if (instances[environment.instance].customerId !== '') {
      this.customerID = instances[environment.instance].customerId;
      this.showCustomerID = false;
    }
    else {
      this.showCustomerID = true;
    }
  }

  /**
   * function that test if the email (in the form) is valid
   * @return {boolean} - true if it's valid, false else
   */
  private isEmailValid(): boolean {
    return EmailValidator.emailIsValid(this.email);
  }

  /**
   * test if all the form is valid
   * @return {boolean}, true if it's valid, false else
   */
  public formIsComplete(): boolean {
    return !!(this.email && this.customerID && this.userID && this.isEmailValid());
  }

  /**
   * function that ask for a password reset.
   */
  public resetPassword(): void {
    this.authenticationService.isWsoRegistered(this.userID, this.customerID).subscribe(isWso2Registered => {
      this.isWsoRegistered = isWso2Registered;
      if(!this.isWsoRegistered){
        this.passwordService.askResetPassword(this.customerID, this.userID, this.email).subscribe(result => {
          if (result) {
            this.forgottenSuccess.emit(true);
            this.commonService.addToast({life: 3000, severity: 'info', summary: this.successTitle, detail: this.successMessage});
          }
          this.resetPasswordFail = !result;
        });
      }
      else{
        this.bShowIsWsoRegisteredErrorMessage = true;
      }
    });

  }

}
